import { getNearestSunday, getWeekAfterStartDate, weeksBetween } from './';
import { WEEK_FORMAT } from './../../coursePlan/helpers/CoursePlanHelper';

export const addEmptyWeeks = (tree: any, newPhase: any) => {
  
  const { phases, weekFormat } = tree;
  const weekTemplate = {
    weekNo: 1,
    startDate: newPhase.startDate,
    endDate: new Date(newPhase.endDate),
    content: [],
    subjects: [],
  };

  addWeeksArray(newPhase, weekTemplate, weekFormat);
  //Update week numbers of other phases
  updateWeekNum(phases);
 
};

const updateWeekNum = (phases: any) => {
  let weekNum = 1;
  for (const phase of phases) {
    for (const week of phase.weeks) {
      week.weekNo = weekNum++;
    }
  }
};


const addWeeksArray = (newPhase: any, weekTemplate: any, weekFormat: string) => {
  const { startDate, endDate } = newPhase;
  const numberOfWeeks = weeksBetween(new Date(startDate), new Date(endDate));

  let weekStartDate = new Date(startDate);
  let weekEndDate = getWeekEndDate(startDate, weekFormat);
if(numberOfWeeks > 0){
  
  for (let i = 0; i < numberOfWeeks; i++) {
    if (weekEndDate.getTime() > new Date(endDate).getTime()) {
      weekEndDate = new Date(endDate);
    }
    const newWeek = { ...weekTemplate, startDate: weekStartDate, endDate: weekEndDate };
   
    newPhase.weeks.push(JSON.parse(JSON.stringify(newWeek)));
    if (weekEndDate.getTime() > new Date(endDate).getTime()) {
      break;
    }
    weekStartDate = new Date(weekEndDate.setDate(weekEndDate.getDate() + 1));
    weekEndDate = getWeekEndDate(weekStartDate, weekFormat);
  }
  } if (numberOfWeeks === 0) {
  
    const newWeek = { ...weekTemplate, startDate: new Date(startDate), endDate: new Date(endDate) };
    newPhase.weeks.push(JSON.parse(JSON.stringify(newWeek)));
}
};

const getWeekEndDate = (startDate: Date, weekFormat: string) => {
  if (weekFormat === WEEK_FORMAT.MON_TO_SUN) {
    return new Date(getNearestSunday(startDate));
  }
  return new Date(getWeekAfterStartDate(startDate));
};


